// eslint-disable-next-line no-shadow
enum States {
  default = 'default',
  loading = 'loading',
  networkError = 'networkError',
  genericError = 'genericError',
}

export { States };
